export default __webpack_public_path__ + "static/media/boys.5a264e6a.mp4";